import { render, staticRenderFns } from "./OccupationSelectionDeleteButton.vue?vue&type=template&id=ca9b85fc&scoped=true&"
import script from "./OccupationSelectionDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./OccupationSelectionDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9b85fc",
  null
  
)

export default component.exports